import React, { useEffect, useState } from "react";
import useActiveSection from "../../hooks/useActiveSection";

const LINKS = [
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const activeId = useActiveSection(LINKS.map((l) => l.id));

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setIsOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-zinc-950/80 backdrop-blur-lg border-b border-white/5" : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <button
          onClick={() => scrollTo("home")}
          className="text-white font-semibold tracking-tight text-lg hover:text-accent-light transition-colors"
        >
          Josh Pascual
        </button>

        <div className="hidden md:flex items-center gap-1">
          {LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`px-4 py-2 text-sm rounded-full transition-colors ${
                activeId === link.id
                  ? "text-white bg-white/10"
                  : "text-zinc-400 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://docs.google.com/document/d/1FAU2p8rl9nKo99RE8XkXtuzGTlOfC_q8I6qTc5-4g2s/export?format=pdf"
            target="_blank"
            rel="noreferrer"
            className="ml-3 px-4 py-2 text-sm rounded-full bg-accent hover:bg-accent-dark text-white transition-colors"
          >
            Resume
          </a>
        </div>

        <button
          onClick={() => setIsOpen((o) => !o)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white text-xl"
          aria-label="Toggle menu"
        >
          <i className={`fa-solid ${isOpen ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      </nav>

      <div
        className={`md:hidden overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          isOpen ? "max-h-80" : "max-h-0"
        }`}
      >
        <div className="px-6 pb-4 flex flex-col gap-1 bg-zinc-950/95 backdrop-blur-lg border-b border-white/5">
          {LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-left px-4 py-3 rounded-lg text-base transition-colors ${
                activeId === link.id ? "text-white bg-white/10" : "text-zinc-400"
              }`}
            >
              {link.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
